import wincomb from '../../../base/js/managers/wincomb';

const wildMulti = [1, 2, 4, 8, 16];

wincomb.getWinByLine = function getWinByLine(symbols) {
  const symbol = symbols.find(s => s !== this.wild && s !== this.scatter);
  const symbolLen = symbol === undefined ? 0 : this.countSymbol(symbol, symbols);
  const wildLen = this.countSymbol(this.wild, symbols);

  const wildWin = this.calcWin(this.wild, wildLen);
  const symbolWin = this.calcWin(symbol, symbolLen);

  const wildLenInComb = symbols.slice(0, symbolLen + 1).filter(s => s === this.wild).length;
  const realSymbolWin = symbolWin * wildMulti[wildLenInComb];

  if (!wildWin && !realSymbolWin) {
    return [0, 0];
  }

  return wildWin > realSymbolWin ? [wildWin, wildLen] : [realSymbolWin, symbolLen];
};

export default wincomb;



// WEBPACK FOOTER //
// ./js/managers/wincomb.js